module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO7_18 (25).48c0986.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO7_18 (25).mp4
// module id = 800
// module chunks = 1